import React from 'react';
import { motion } from 'framer-motion';
import { translations } from '../translations';

function FloatingMemory({ uploadedImage, language = 'en' }) {
  const t = translations[language] || translations.en;

  if (!uploadedImage) return null;

  return (
    <motion.div
      initial={{ opacity: 0, rotate: -10, scale: 0.8 }}
      animate={{ 
        opacity: 1, 
        rotate: [-5, 5, -5],
        y: [-10, 10, -10],
        scale: 1
      }}
      transition={{ 
        rotate: { duration: 6, repeat: Infinity, ease: "easeInOut" },
        y: { duration: 4, repeat: Infinity, ease: "easeInOut" },
        opacity: { duration: 1 },
        scale: { duration: 1 }
      }}
      className="absolute right-12 bottom-32 z-20 pointer-events-none"
    >
      <div className="relative bg-white p-4 pb-12 shadow-2xl transform rotate-3 max-w-xs md:max-w-sm rounded-sm">
        {/* Tape Effect */}
        <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 w-32 h-8 bg-white/30 backdrop-blur-sm shadow-sm rotate-1 z-10" />
        
        {/* Image Container */}
        <div className="aspect-[4/5] w-full overflow-hidden bg-gray-100 mb-4 shadow-inner">
          <img 
            src={uploadedImage} 
            alt="Memory" 
            className="w-full h-full object-cover"
          />
        </div>

        {/* Caption */}
        <div className="absolute bottom-4 left-0 w-full text-center">
          <p className="font-handwriting text-gray-600 text-xl font-medium" style={{ fontFamily: 'cursive' }}>
            {t.yourMemory}
          </p>
        </div>

        {/* Shinies */}
        <motion.div 
          animate={{ opacity: [0, 0.5, 0], x: [-100, 100] }}
          transition={{ duration: 2, repeat: Infinity, repeatDelay: 3 }}
          className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-transparent via-white/20 to-transparent skew-x-12 pointer-events-none"
        />
      </div>
    </motion.div>
  );
}

export default FloatingMemory;